<template>
    <div class="ml-3">
        <b-button variant="outline-default" @click="requestCancel">
            Solicitar Cancelamento
        </b-button>

        <b-modal
            id="cancel-modal"
            title="Solicitar Cancelamento"
            cancel-variant="default"
            ok-variant="danger"
            ok-title="Socilitar Cancelamento"
            cancel-title="Fechar"
            @ok="requestCancelAccept"
        >
            <div>
                <b-textarea v-model="form.reason" placeholder="Poderia nos dizer o motivo do cancelamento?" />
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            cancel: null,
            form: {
                reason: null
            }
        }
    },
    created() {
        this.loadCancel();

        this.$root.$on('reloadCancels', () => {
            this.loadCancel();
        });
    },
    destroyed() {
        this.$root.$off('reloadCancels');
    },
    methods: {
        loadCancel() {
            axios.get('/teacher/pagarme/subscription/cancel')
                .then(response => {
                    this.cancel = response.data.data.cancel || null;
                });
        },

        requestCancel() {
            this.$bvModal.show('cancel-modal');
        },

        requestCancelAccept() {
            this.loading = true;
            axios.post('/teacher/pagarme/subscription/cancel', this.form)
                .then(() => {
                    this.$bvModal.hide('cancel-modal');

                    this.$toast.success('Solicitação de cancelamento enviada com sucesso! Em breve entraremos em contato para confirmar o cancelamento.', {
                        autoHideDelay: 7000,
                    });

                    this.$root.$emit('reloadCancels');
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>
<style>

</style>
